













import { Action } from 'vuex-class'
import { Prop, Component } from 'vue-property-decorator'
import _ from 'lodash'
import { IJob } from '@/store/modules/views/job/states'
import VueExtendedBaseComponent from '@/VueExtendedBaseComponent.vue'

@Component
export default class DeleteJobDialog extends VueExtendedBaseComponent {
  @Prop() private open!: boolean
  @Prop() private job!: IJob
  @Prop() private callback!: () => Promise<void>

  private loading = false

  get openDialog() {
    return this.open
  }

  set openDialog(value: boolean) {
    this.$emit('update:open', false)
  }

  get deleteJobDialogOption() {
    return {
      justify: 'start',
      button: {
        justify: 'center',
        cancelButton: {
          title: 'ปิด',
          action: this.closeDialog,
          height: '30',
        },
        submitButton: {
          title: 'ลบ',
          action: this.deleteJobAction,
          loading: this.loading,
          height: '30',
        },
      },
    }
  }

  @Action('job/deleteJob')
  private deleteJob!: (options: {}) => Promise<void>

  private async deleteJobAction() {
    this.loading = true
    try {
      await this.deleteJob({
        _id: this.job._id,
      })
      this.updateSnackbar({txt: 'ลบข้อมูลบริการสำเร็จ.', type: 'success'})
      await this.callback()
      this.closeDialog()
    } catch (e) {
      this.loading = false
    }
  }

  private closeDialog() {
    this.$emit('update:open', false)
  }
}
